import { render, staticRenderFns } from "./SelecionarPerfil.vue?vue&type=template&id=21b1da2a&scoped=true&lang=pug&"
import script from "./SelecionarPerfil.vue?vue&type=script&lang=js&"
export * from "./SelecionarPerfil.vue?vue&type=script&lang=js&"
import style0 from "./SelecionarPerfil.vue?vue&type=style&index=0&id=21b1da2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b1da2a",
  null
  
)

export default component.exports